var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMirrorCreateteam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 340",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .st4{fill:#838c91}.st5{font-family:&apos;HelveticaNeue&apos;}.st9{fill:none;stroke:#edeff0;stroke-width:.8438}.st12{fill:#17394d}.st13{font-family:&apos;HelveticaNeue-Bold&apos;}.st14{font-size:8px}.st15{fill:#6b808c}.st16{font-size:7px}.st19,.st22{opacity:.35;enable-background:new}.st19{fill-rule:evenodd;clip-rule:evenodd;fill:#5f98c2}.st22{fill:#fff}\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Trello---MASTER"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    d: "M4 0h312c2.2 0 4 1.8 4 4v332c0 2.2-1.8 4-4 4H4c-2.2 0-4-1.8-4-4V4c0-2.2 1.8-4 4-4z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#eff3f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "bg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    d: "M75.7 72h167.6c.9 0 1.7.8 1.7 1.7v195.6c0 .9-.8 1.7-1.7 1.7H75.7c-.9 0-1.7-.8-1.7-1.7V73.7c0-.9.8-1.7 1.7-1.7z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7 72.3c-.8 0-1.4.6-1.4 1.4v195.6c0 .8.6 1.4 1.4 1.4h167.6c.8 0 1.4-.6 1.4-1.4V73.7c0-.8-.6-1.4-1.4-1.4H75.7z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff",
    stroke: "#d6dadc",
    strokeWidth: 0.563
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#f6f6f7",
    d: "M75.1 159H244v54H75.1z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(83 76.5)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(65.17 7.563)",
    className: "st4 st5",
    fontSize: 7.875
  }, "\n          Create\n        "), /*#__PURE__*/React.createElement("g", {
    transform: "translate(139.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "x",
    transform: "rotate(45 3.692 8.045)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    className: "st4",
    d: "M5 .5c.3 0 .6.2.6.6v3.4H9c.3 0 .5.2.6.5v.1c0 .3-.2.6-.6.6H5.6v3.4c0 .3-.2.5-.5.6L5 9.5c-.3 0-.6-.2-.6-.6V5.5H1C.7 5.5.5 5.3.5 5v-.1c0-.3.2-.6.6-.6h3.4V.9c-.1-.2.1-.4.5-.4z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Line",
    d: "M.2 17.7h152.6",
    fill: "none",
    stroke: "#d6dadc",
    strokeWidth: 0.563,
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(83 116)",
    className: "st12 st13 st14"
  }, "\n        Create Board\u2026\n      "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(83 171)",
    className: "st12 st13 st14"
  }, "\n        Create Team\u2026\n      "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(83 226)",
    className: "st12 st13 st14"
  }, "\n        Create Business Team\u2026\n      "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(83 129.25)",
    className: "st15 st5 st16"
  }, "\n        A board is made up of cards ordered on lists.\n      "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(83 139.25)",
    className: "st15 st5 st16"
  }, "\n        Use it to manage projects, track information, or\n      "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(83 149.25)",
    className: "st15 st5 st16"
  }, "\n        organize anything.\n      "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(83 184.25)",
    className: "st15 st5 st16"
  }, "\n        A team is a group of boards and people. Use it\n      "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(83 194.25)",
    className: "st15 st5 st16"
  }, "\n        to organize your company, side hustle, family or\n      "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(83 204.25)",
    className: "st15 st5 st16"
  }, "\n        friends.\n      "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(83 239.25)",
    className: "st15 st5 st16"
  }, "\n        With Business Class your team has more\n      "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(83 249.25)",
    className: "st15 st5 st16"
  }, "\n        security, administrative controls, and unlimited\n      "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(83 259.25)",
    className: "st15 st5 st16"
  }, "\n        Power-Ups.\n      "), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#026aa6",
    d: "M74 48h171v23H74z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169 53h12c1.1 0 2 .9 2 2v11c0 1.1-.9 2-2 2h-12c-1.1 0-2-.9-2-2V55c0-1.1.9-2 2-2z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#5f98c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy-4",
    className: "st19",
    d: "M187 53h12c1.1 0 2 .9 2 2v11c0 1.1-.9 2-2 2h-12c-1.1 0-2-.9-2-2V55c0-1.1.9-2 2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy-5",
    className: "st19",
    d: "M205 53h12c1.1 0 2 .9 2 2v11c0 1.1-.9 2-2 2h-12c-1.1 0-2-.9-2-2V55c0-1.1.9-2 2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy-6",
    d: "M228.5 53h1c4.1 0 7.5 3.4 7.5 7.5s-3.4 7.5-7.5 7.5h-1c-4.1 0-7.5-3.4-7.5-7.5s3.4-7.5 7.5-7.5z",
    opacity: 0.35,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p",
    d: "M178 60h.1v.6h-2.6v2.6h-.5-.1v-2.6h-2.5-.1v-.5-.1h2.6v-2.5-.1h.6V60h2.5z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "i",
    className: "st22",
    d: "M193.5 57c.6 0 1.2.2 1.7.5s.9.7 1.2 1.2c.3.5.5 1.1.5 1.7s-.2 1.2-.5 1.7-.7.9-1.2 1.2c-.5.3-1.1.5-1.7.5-.6 0-1.2-.2-1.7-.5s-.9-.7-1.2-1.2c-.3-.5-.5-1.1-.5-1.7s.2-1.2.5-1.7.7-.9 1.2-1.2c.5-.4 1.1-.5 1.7-.5zm0 6.1c.5 0 .9-.1 1.4-.4.4-.2.8-.6 1-1s.4-.9.4-1.4c0-.5-.1-.9-.4-1.4-.2-.4-.6-.8-1-1-.4-.2-.9-.4-1.4-.4-.5 0-.9.1-1.4.4-.4.2-.8.6-1 1-.2.4-.4.9-.4 1.4 0 .5.1.9.4 1.4s.6.8 1 1c.5.3.9.4 1.4.4zm0-4.6c.2 0 .3.1.4.2.1.1.2.2.2.4s-.1.3-.2.4c-.1.1-.2.2-.4.2s-.3-.1-.4-.2c-.1-.1-.2-.2-.2-.4s.1-.3.2-.4c.1-.2.2-.2.4-.2zm.8 3.5v.1H193h-.1v-.4-.1H193.2v-.9h-.2-.1v-.4-.1h1.1v1.5H194.3V62z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    className: "st22",
    d: "M213.8 61.4c.2.2.3.4.3.7 0 .2-.1.5-.3.6s-.4.3-.6.3h-1.3c0 .2-.1.5-.3.6-.2.2-.4.3-.6.3-.2 0-.5-.1-.6-.3-.2-.2-.3-.4-.3-.6h-1.3c-.3 0-.5-.1-.6-.3s-.3-.4-.3-.6c0-.3.1-.5.3-.7.1-.1.2-.2.2-.3.1-.1.1-.3.2-.5 0-.2.1-.5.1-.9s.1-.7.3-1c.2-.3.4-.6.7-.8.3-.2.6-.3 1-.4-.1-.1-.1-.2-.1-.2 0-.1 0-.2.1-.3.1-.1.2-.1.3-.1.1 0 .2 0 .3.1.1.1.1.2.1.3 0 .1 0 .2-.1.2.4.1.7.2 1 .4.3.2.5.5.7.8.2.3.3.7.3 1 0 .3 0 .6.1.9 0 .2.1.3.2.5 0 .1.1.2.2.3zm-2.7 1.9c.1 0 .2 0 .2-.1.1-.1.1-.1.1-.2h-.7c0 .1 0 .2.1.2.1.1.2.1.3.1zm2.1-1c.1 0 .2-.1.2-.2s0-.2-.1-.3l-.4-.4c-.1-.2-.2-.4-.2-.6-.1-.3-.1-.6-.1-1.1 0-.3-.1-.6-.2-.8-.1-.3-.3-.4-.6-.6-.3-.1-.5-.2-.8-.2-.3 0-.6.1-.8.2-.3.1-.4.3-.6.6-.1.3-.2.5-.2.8 0 .4 0 .8-.1 1-.1.2-.1.5-.2.6-.1.1-.2.3-.4.4-.1.1-.1.2-.1.3 0 .1.1.2.2.2h4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u",
    className: "st22",
    d: "M229 56c.4 0 .9.1 1.2.3.4.2.7.5.9.9.2.4.3.8.3 1.2 0 .4-.1.9-.3 1.2s-.5.7-.9.9c-.4.2-.8.3-1.2.3-.4 0-.9-.1-1.2-.3-.4-.2-.7-.5-.9-.9-.2-.4-.3-.8-.3-1.2 0-.4.1-.9.3-1.2.2-.4.5-.7.9-.9.3-.2.8-.3 1.2-.3zm2.9 5.2c.3.1.6.3.8.5.2.3.3.6.3.9v.6c0 .2-.1.4-.2.5-.1.1-.3.2-.5.2h-6.5c-.2 0-.4-.1-.5-.2-.1-.1-.2-.3-.2-.5v-.6c0-.3.1-.7.3-.9s.5-.4.8-.5l1.1-.3c.5.4 1 .5 1.7.6.7 0 1.3-.2 1.8-.6l1.1.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMirrorCreateteam);
export default __webpack_public_path__ + "static/media/mirror_createteam.0df41ecfda9b01a215d1632eaeb70415.svg";
export { ForwardRef as ReactComponent };